'use client';

import type { ReactNode } from 'react';

/**
 * Pill / tab segment. DESIGN.md §8.5.
 *
 * Used standalone for static tags, or grouped inside a {@link PillGroup}
 * container that renders a sunken track behind the pills.
 */
export function Pill({
  active = false,
  children,
  onClick,
  className,
}: {
  active?: boolean;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  const base =
    'pressable inline-flex h-8 items-center justify-center rounded-full px-3 text-xs font-medium ' +
    'transition-colors select-none';
  const tone = active
    ? 'bg-raised text-fg-primary shadow-sm'
    : 'bg-transparent text-fg-muted hover:text-fg-primary';
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`${base} ${tone} ${className ?? ''}`}
    >
      {children}
    </button>
  );
}

export function PillGroup({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={
        'inline-flex items-center gap-1 rounded-full bg-sunken p-1 ' + (className ?? '')
      }
    >
      {children}
    </div>
  );
}
